import { useCallback, useEffect, useState } from 'react';
import { EVENTS, STATUS, Step, useJoyride } from 'react-joyride';
import { filterJoyrideSteps } from './filterJoyrideSteps';
import { markTourSeen, TourStorageStatus } from './tourStorage';
import { sittJoyrideBaseOptions } from './sittJoyrideTheme';

interface UseSittJoyrideOptions {
    storageKey?: string;
}

export function useSittJoyride({ storageKey }: UseSittJoyrideOptions = {}) {
    const [steps, setSteps] = useState<Step[]>([]);

    const { Tour, controls, on } = useJoyride({
        ...sittJoyrideBaseOptions,
        steps,
    });

    useEffect(() => {
        return on(EVENTS.TOUR_END, (data) => {
            if (!storageKey) return;
            if (data.status === STATUS.FINISHED) {
                markTourSeen(storageKey, 'completed');
            }
            if (data.status === STATUS.SKIPPED) {
                markTourSeen(storageKey, 'skipped');
            }
        });
    }, [on, storageKey]);

    const runTour = useCallback(
        (nextSteps: Step[]) => {
            const filtered = filterJoyrideSteps(nextSteps);
            if (filtered.length === 0) return;
            setSteps(filtered);
            window.setTimeout(() => {
                controls.reset(true);
                controls.start(0);
            }, 80);
        },
        [controls],
    );

    const markSeen = useCallback(
        (status: TourStorageStatus) => {
            if (storageKey) markTourSeen(storageKey, status);
        },
        [storageKey],
    );

    return { Tour, runTour, markSeen };
}
